<template>
  <div class="info">
    <lb-table
      v-if="!isDetail"
      v-loading="loading"
      v-horizontal-scroll="'always'"
      :column="columns"
      :data="page.list"
      pagination
      :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      @selection-change="onMultipleSelection"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </lb-table>
    <lb-table
      v-if="isDetail"
      v-loading="loading"
      v-horizontal-scroll="'always'"
      :column="columns1"
      :data="page1.list"
      pagination
      :total="page1.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page1.currentPage"
      :page-size="page1.pageSize"
      @size-change="handleSizeChange1"
      @p-current-change="handleCurrentChange1"
    >
    </lb-table>
    <div style="display: flex; justify-content: center" v-if="isDetail">
      <div class="back" @click="back">返回</div>
    </div>
  </div>
</template>
  <script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  components: {
    LbTable
  },
  data () {
    return {
      isDetail: false,
      name: 'cdd',
      list: [{
        name: 'cdd'
      },
      {
        name: 'cdd'
      }, {
        name: 'cdd'
      }, {
        name: 'cdd'
      }
      ],
      columns: [
        { label: '领取时间', prop: 'drawTime', minWidth: '120' },
        { label: '优惠券名称', prop: 'name', minWidth: '220' },
        { label: '优惠金额', prop: 'price', minWidth: '120' },
        { label: '最低使用金额', prop: 'minPrice', minWidth: '120' },
        { label: '已领取', prop: 'hasNum', minWidth: '120' },
        { label: '已使用', prop: 'useNum', minWidth: '120' },
        { label: '已过期(失效)', prop: 'expireNum', minWidth: '120' },
        { label: '未使用', prop: 'unUseNum', minWidth: '120' },
        {
          label: '使用详情', prop: 'applyStatusLabel', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                {/* <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.look(scope.row.id) }}>查看</span> */}
                <el-link size='mini' type='primary' onClick={() => { this.look(scope.row.id) }}>查看</el-link>
              </div>
            )
          }
        }
      ],
      columns1: [
        { label: '使用时间', prop: 'useTime', minWidth: '120' },
        { label: '订单编号', prop: 'orderNo', minWidth: '220' },
        {
          label: '订单商品', prop: 'name', minWidth: '220',
          renderHeader: (h, scope) => {
            return (
              <div style="text-align:left">订单商品</div>
            )
          },
          render: (h, scope) => {
            if (!scope.row.goodsInfoList) return
            return (
              <div>
                {
                  scope.row.goodsInfoList.map(item => {
                    return (
                      <p style="display:flex;flex-direction:column"><p style="text-align:left">{item.name}</p><p style="text-align:left">{item.sku + '*' + item.num}</p></p>
                    )
                  })
                }
              </div>
            )
          }
        },
        { label: '金额', prop: 'price', minWidth: '120' },

      ],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      page1: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      loading: true,
      cId: ''
    }
  },
  watch: {
    id (val, vall) {
      this.id = val
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    look (id) {
      this.cId = id
      this.isDetail = true
      this.fetchData1()
    },
    back () {
      this.isDetail = false
      this.fetchData()
    },
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    handleCurrentChange1 (currentChange) {
      this.page1.pageNo = currentChange
      this.fetchData1()
    },
    handleSizeChange1 (sizeChange) {
      this.page1.pageSize = sizeChange
      this.fetchData1()
    },
    fetchData () {
      let data = {
        userId: this.id,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      this.$api.getCouponPageUserList(data).then(res => {
        this.page.list = res.data.list
        this.page.totalNum = res.data.totalNum
        this.loading = false
      })
    },
    fetchData1 () {
      let data = {
        userId: Number(this.id),
        couponId: this.cId,
        pageNo: this.page1.pageNo,
        pageSize: this.page1.pageSize
      }
      this.$api.getCouponUseList(data).then(res => {
        res.data.list.forEach(item => {
          let arr = []
          item.name.split(',').forEach(itm => {
            let obj = {
              name: itm.split('+')[0],
              sku: itm.split('+')[1],
              num: itm.split('+')[2]
            }
            console.log(obj)
            arr.push(obj)
          })
          Object.assign(item, { goodsInfoList: arr })
        })
        this.page1.list = res.data.list
        this.page1.totalNum = res.data.totalNum
        this.loading = false
      })
    }
  }
}
  </script>
  <style scoped>
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
.back {
  width: 220px;
  height: 48px;
  background: #f2a626;
  opacity: 1;
  border-radius: 4px;
  text-align: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #ffffff;
}
</style>
  
  